<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-form-group label="Título">
          <b-form-input v-model="card_link.title"></b-form-input>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-card>
          <div class="d-flex mb-2">
            <div class="mr-auto"></div>
            <div>
              <b-button size="sm" variant="bagsis" @click="openModalCard()">
                <font-awesome-icon icon="plus" />
                Adicionar Card
              </b-button>
            </div>
          </div>

          <b-row>
            <b-col
              v-for="(card_link_item, i) in card_link.card_link_itens"
              :key="'item-' + card_link_item.id"
              cols="4"
            >
              <b-card :title="card_link_item.title" class="card-link-item">
                <div class="card-link-item-actions">
                  <b-button
                    size="sm"
                    variant="bagsis"
                    @click="editItem(i)"
                    class="btn-delete"
                  >
                    <font-awesome-icon icon="edit" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="deleteItem(i)"
                    class="btn-delete"
                  >
                    <font-awesome-icon icon="trash" />
                  </b-button>
                </div>
                <small>Abrir em {{ targets[card_link_item.target] }}</small>
                <div>{{ card_link_item.url }}</div>
                <small>{{ card_link_item.info }}</small>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModalCard"
      title="Dados do Card"
      size="md"
      centered
      body-class="py-0"
      hide-footer
    >
      <FormCardLinkItem
        ref="FormCardLinkItem"
        @cancel="showModalCard = false"
        @save="submitCardLinkItem"
      />
    </b-modal>
  </div>
</template>

<script>
import { watch } from "vue";
import FormCardLinkItem from "../FormCardLinkItem.vue";
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  components: { FormCardLinkItem },
  data: () => ({
    showModalCard: false,
    card_link: {
      title: "",
      card_link_itens: [],
    },
    targets: {
      _blank: "Nova Página",
      _self: "Mesma Página",
    },
    editing: null,
  }),
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // ...mapState("conselhos", ["conselho", "layout"]),
  },
  methods: {
    isValid() {
      return true;
    },
    openModalCard() {
      this.editing = null;
      this.showModalCard = true;
    },
    submitCardLinkItem(cardLinkItem) {
      this.showModalCard = false;

      if (this.editing !== null) {
        this.card_link.card_link_itens[this.editing] = cardLinkItem;
      } else {
        this.card_link.card_link_itens.push(cardLinkItem);
      }
      this.editing = null;
    },
    editItem(i) {
      this.openModalCard();

      this.$nextTick(() => {
        this.editing = i;
        let cardLinkItem = this.card_link.card_link_itens[i];
        this.$refs["FormCardLinkItem"].setCardLinkItem(cardLinkItem);
      });
    },
    deleteItem(index) {
      this.card_link.card_link_itens.splice(index, 1);
    },
  },
  watch: {
    card_link: {
      deep: true,
      handler: function (value) {
        this.$emit("input", value);
      },
    },
    value: {
      deep: true,
      handler: function (value) {
        if (value) {
          this.card_link = value;
        }
      },
    },
  },
  created() {
    if (this.value) {
      this.card_link = this.value;
    }
  },
};
</script>

<style lang="scss">
.card-link-item {
  border: 1px solid #ddd;
  border-radius: 10px;
  margin-bottom: 1rem;

  .card-link-item-actions {
    position: absolute;
    top: 5px;
    right: 5px;
    display: none;
  }

  &:hover {
    .card-link-item-actions {
      display: inline;
    }
  }
}
</style>
